import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GetglobalsettingsService } from './getglobalsettings.service';
import { PreflightResult } from '../shared/document-preflight';

/**
 * REST client for the invoice pre-flight check, `GET /Document/:id/Preflight` on the webapi backend
 * (`webyto_api-express4-TS-20250331/docs/DOCUMENT_PREFLIGHT_API.md`). Read-only; it checks the SAVED version of the
 * document, so callers must not run it while there are unsaved edits.
 *
 * No `retry()`: the check is a few seconds of database work, and a user who sees an error can press the button again.
 * Errors are not caught here; the caller subscribes with its own `error` handler.
 */
@Injectable({
  providedIn: 'root'
})
export class DocumentPreflightApiService {

  constructor(
    private http: HttpClient,
    private globalsettingsservice: GetglobalsettingsService,
  ) {
  }

  /**
   * @param docId - The invoice `DOCID` (numeric, so it needs no encoding).
   * @param s1 - Main depot, required.
   * @param s2 - Import depot, 0 = not used.
   * @param s3 - Auxiliary depot, 0 = not used.
   * @param md - Manufacturing depot for the `manued` figure of a holder; omitted or 0 lets the API use its default.
   */
  getPreflight(docId: number, s1: number, s2: number = 0, s3: number = 0, md: number = 0): Observable<PreflightResult> {
    let params = new HttpParams().set('_s1', String(s1)).set('_s2', String(s2)).set('_s3', String(s3));
    if (md > 0) { params = params.set('_md', String(md)); }

    return this.http.get<PreflightResult>(
      this.globalsettingsservice.getApiServerUrl() + '/Document/' + docId + '/Preflight',
      { headers: { ...this.globalsettingsservice.getConnectionOptions() }, params }
    );
  }
}
